import { Component, effect, input, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FloatingInputComponent } from '../../../../framework/inputs/floating-input/floating-input.component';
import { RegistrationForm } from '../../auth.constants';

@Component({
  selector: 'app-register-manager-form',
  imports: [FloatingInputComponent, ReactiveFormsModule],
  templateUrl: './register-manager-form.component.html',
  styleUrls: ['./register-manager-form.component.scss'],
})
export class RegisterManagerFormComponent {
  @Input({ required: true }) registrationForm: FormGroup<RegistrationForm>;
  invitationToken = input<string>();

  constructor() {
    effect(() => {
      const invitationToken = this.invitationToken();
      if (invitationToken) {
        this.registrationForm.controls.email.disable();
      }
    });
  }
}
